module.exports = __webpack_public_path__ + "media/images/icons/country_flags/at-d9c6c6ac800a2ecd563e00bf13f0fdcf.svg";